import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=0062ae98&scoped=true&"
import script from "./Posts.vue?vue&type=script&lang=js&"
export * from "./Posts.vue?vue&type=script&lang=js&"
import style0 from "./Posts.vue?vue&type=style&index=0&id=0062ae98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062ae98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0062ae98')) {
      api.createRecord('0062ae98', component.options)
    } else {
      api.reload('0062ae98', component.options)
    }
    module.hot.accept("./Posts.vue?vue&type=template&id=0062ae98&scoped=true&", function () {
      api.rerender('0062ae98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cancellations/Posts.vue"
export default component.exports